// import { useState, useRef } from "react";
// import "./imageZoom.scss";

// export default function ImageZoom({ src, alt, className }) {
//   const [open, setOpen] = useState(false);
//   const [rect, setRect] = useState(null);
//   const imgRef = useRef();

//   const handleOpen = () => {
//     const bounds = imgRef.current.getBoundingClientRect();
//     setRect(bounds);
//     setOpen(true);
//   };

//   return (
//     <>
//       <img
//         ref={imgRef}
//         src={src}
//         alt={alt}
//         className={className} // 👈 use your own styles
//         onClick={handleOpen}
//       />

//       {open && rect && (
//         <div className="overlay" onClick={() => setOpen(false)}>
//           <img
//             src={src}
//             alt={alt}
//             className="zoomImage"
//             style={{
//               top: rect.top,
//               left: rect.left,
//               width: rect.width,
//               height: rect.height,
//             }}
//           />
//         </div>
//       )}
//     </>
//   );
// }

// import { useState, useRef } from "react";
// import "./imageZoom.scss";
// import { IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// export default function ImageZoom({ src, alt, className }) {
//   const [open, setOpen] = useState(false);
//   const [style, setStyle] = useState({});
//   const [animating, setAnimating] = useState(false);
//   const imgRef = useRef();

//   const handleOpen = () => {
//     const rect = imgRef.current.getBoundingClientRect();

//     // Start from original position
//     setStyle({
//       top: rect.top,
//       left: rect.left,
//       width: rect.width,
//       height: rect.height,
//       transform: "translate(0,0) scale(1)",
//       transition: "all 0.5s ease",
//     });

//     setOpen(true);

//     requestAnimationFrame(() => {
//       setAnimating(true);

//       // Animate to fullscreen
//       setStyle({
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%) scale(1)",
//         width: "auto",
//         height: "auto",
//         maxWidth: "95vw",
//         maxHeight: "95vh",
//         transition: "all 0.5s ease",
//       });
//     });
//   };

//   const handleClose = () => {
//     const rect = imgRef.current.getBoundingClientRect();

//     setAnimating(true);

//     // Animate BACK to original position
//     setStyle({
//       top: rect.top,
//       left: rect.left,
//       width: rect.width,
//       height: rect.height,
//       transform: "translate(0,0) scale(1)",
//       transition: "all 0.5s ease",
//     });

//     // Wait for animation to finish
//     setTimeout(() => {
//       setOpen(false);
//       setAnimating(false);
//     }, 500);
//   };

//   return (
//     <>
//       <img
//         ref={imgRef}
//         src={src}
//         alt={alt}
//         className={`transition ${className}`}
//         onClick={handleOpen}
//       />

//       {open && (
//         <div
//           className={`overlay ${animating ? "show" : ""}`}
//           onClick={handleClose}
//         >
//           <IconButton
//             variant="contained"
//             aria-label="close"
//             size="medium"
//             className="btn-close"
//           >
//             <CloseIcon />
//           </IconButton>
//           <img
//             src={src}
//             alt={alt}
//             className={`zoomImage transition ${animating ? "animate" : ""}`}
//             style={style}
//           />
//         </div>
//       )}
//     </>
//   );
// }

import { useState, useRef } from "react";
import "./imageZoom.scss";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ImageZoom({ src, alt, className }) {
  const [open, setOpen] = useState(false);
  const [style, setStyle] = useState({});
  const [animate, setAnimate] = useState(false);
  const imgRef = useRef();

  const handleOpen = () => {
    const rect = imgRef.current.getBoundingClientRect();

    // STEP 1: set initial (thumbnail) size
    setStyle({
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      transform: "translate(0,0)",
      objectFit: rect.objectFit,
      objectPosition: rect.objectPosition,
    });

    setOpen(true);

    // STEP 2: wait → then animate
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setAnimate(true);

        setStyle({
          top: "50%",
          left: "50%",
          width: "95vw",
          height: "95vh",
          transform: "translate(-50%, -50%)",
          objectFit: "contain",
          objectPosition: "unset !important",
        });
      });
    });
  };

  const handleClose = () => {
    const rect = imgRef.current.getBoundingClientRect();

    setAnimate(true);

    // animate back
    setStyle({
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      transform: "translate(0,0)",
      objectFit: rect.objectFit,
      objectPosition: rect.objectPosition,
    });

    setTimeout(() => {
      setOpen(false);
      setAnimate(false);
    }, 400);
  };

  return (
    <>
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        className={className}
        onClick={handleOpen}
      />

      {open && (
        <div
          className={`overlay ${animate ? "show" : ""}`}
          onClick={handleClose}
        >
          <IconButton
            variant="contained"
            aria-label="close"
            size="medium"
            className="btn-close"
          >
            <CloseIcon />
          </IconButton>
          <img
            src={src}
            alt={alt}
            className={`zoomImage ${animate ? "animate" : ""}`}
            style={style}
          />
        </div>
      )}
    </>
  );
}
